import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import canvasReducer from "./slices/canvasSlice";
import userReducer from "./slices/userSlice";
import qrScanReducer from "./slices/qrScanSlice";
import presetReducer from "./slices/stationSlice";
import uploadFlowReducer from "./slices/uploadFlowSlice";
import cartReducer from "./slices/cartSlice";
import favouritesReducer from "./slices/favouritesSlice";
import kioskReducer from "./slices/kioskSlice";
import museumReducer from "./slices/museumSlice";


const rootReducer = combineReducers({
    canvas: canvasReducer,
    user: userReducer,
    qrScan: qrScanReducer,
    preset: presetReducer,
    uploadFlow: uploadFlowReducer,
    cart: cartReducer,
    favourites: favouritesReducer,
    kiosk: kioskReducer,
    museum: museumReducer,
});

const persistConfig = {
    key: "root",
    storage,
    whitelist: ["preset", "uploadFlow", "cart"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export const persistor = persistStore(store);

/** Pre-persist shape so slice keys (e.g. uploadFlow) stay typed — not PersistPartial. */
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
